/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingRoomTypeRqDto } from './traveline-booking-room-type-rq-dto';
import {
    TravelineBookingRoomTypeRqDtoFromJSON,
    TravelineBookingRoomTypeRqDtoFromJSONTyped,
    TravelineBookingRoomTypeRqDtoToJSON,
    TravelineBookingRoomTypeRqDtoToJSONTyped,
} from './traveline-booking-room-type-rq-dto';
import type { TravelineExtraStayDto } from './traveline-extra-stay-dto';
import {
    TravelineExtraStayDtoFromJSON,
    TravelineExtraStayDtoFromJSONTyped,
    TravelineExtraStayDtoToJSON,
    TravelineExtraStayDtoToJSONTyped,
} from './traveline-extra-stay-dto';
import type { TravelineRoomStayServiceRqDto } from './traveline-room-stay-service-rq-dto';
import {
    TravelineRoomStayServiceRqDtoFromJSON,
    TravelineRoomStayServiceRqDtoFromJSONTyped,
    TravelineRoomStayServiceRqDtoToJSON,
    TravelineRoomStayServiceRqDtoToJSONTyped,
} from './traveline-room-stay-service-rq-dto';
import type { TravelineBookingRatePlanRqDto } from './traveline-booking-rate-plan-rq-dto';
import {
    TravelineBookingRatePlanRqDtoFromJSON,
    TravelineBookingRatePlanRqDtoFromJSONTyped,
    TravelineBookingRatePlanRqDtoToJSON,
    TravelineBookingRatePlanRqDtoToJSONTyped,
} from './traveline-booking-rate-plan-rq-dto';
import type { TravelineBookingGuestCountDto } from './traveline-booking-guest-count-dto';
import {
    TravelineBookingGuestCountDtoFromJSON,
    TravelineBookingGuestCountDtoFromJSONTyped,
    TravelineBookingGuestCountDtoToJSON,
    TravelineBookingGuestCountDtoToJSONTyped,
} from './traveline-booking-guest-count-dto';
import type { TravelineBookingGuestDto } from './traveline-booking-guest-dto';
import {
    TravelineBookingGuestDtoFromJSON,
    TravelineBookingGuestDtoFromJSONTyped,
    TravelineBookingGuestDtoToJSON,
    TravelineBookingGuestDtoToJSONTyped,
} from './traveline-booking-guest-dto';
import type { TravelineBookingStayDatesDto } from './traveline-booking-stay-dates-dto';
import {
    TravelineBookingStayDatesDtoFromJSON,
    TravelineBookingStayDatesDtoFromJSONTyped,
    TravelineBookingStayDatesDtoToJSON,
    TravelineBookingStayDatesDtoToJSONTyped,
} from './traveline-booking-stay-dates-dto';

/**
 * Room accommodation entity
 * @export
 * @interface TravelineBookingRoomStayRqDto
 */
export interface TravelineBookingRoomStayRqDto {
    /**
     * 
     * @type {TravelineBookingStayDatesDto}
     * @memberof TravelineBookingRoomStayRqDto
     */
    stayDates: TravelineBookingStayDatesDto;
    /**
     * 
     * @type {TravelineBookingRatePlanRqDto}
     * @memberof TravelineBookingRoomStayRqDto
     */
    ratePlan: TravelineBookingRatePlanRqDto;
    /**
     * 
     * @type {TravelineBookingRoomTypeRqDto}
     * @memberof TravelineBookingRoomStayRqDto
     */
    roomType: TravelineBookingRoomTypeRqDto;
    /**
     * Guests entity
     * @type {Array<TravelineBookingGuestDto>}
     * @memberof TravelineBookingRoomStayRqDto
     */
    guests: Array<TravelineBookingGuestDto>;
    /**
     * 
     * @type {TravelineBookingGuestCountDto}
     * @memberof TravelineBookingRoomStayRqDto
     */
    guestCount: TravelineBookingGuestCountDto;
    /**
     * Check hash sum of accommodation conditions
     * @type {string}
     * @memberof TravelineBookingRoomStayRqDto
     */
    checksum: string;
    /**
     * Extra services in a booking<br />
     * @type {Array<TravelineRoomStayServiceRqDto>}
     * @memberof TravelineBookingRoomStayRqDto
     */
    services?: Array<TravelineRoomStayServiceRqDto> | null;
    /**
     * 
     * @type {TravelineExtraStayDto}
     * @memberof TravelineBookingRoomStayRqDto
     */
    extraStay?: TravelineExtraStayDto;
}

/**
 * Check if a given object implements the TravelineBookingRoomStayRqDto interface.
 */
export function instanceOfTravelineBookingRoomStayRqDto(value: object): value is TravelineBookingRoomStayRqDto {
    if (!('stayDates' in value) || value['stayDates'] === undefined) return false;
    if (!('ratePlan' in value) || value['ratePlan'] === undefined) return false;
    if (!('roomType' in value) || value['roomType'] === undefined) return false;
    if (!('guests' in value) || value['guests'] === undefined) return false;
    if (!('guestCount' in value) || value['guestCount'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    return true;
}

export function TravelineBookingRoomStayRqDtoFromJSON(json: any): TravelineBookingRoomStayRqDto {
    return TravelineBookingRoomStayRqDtoFromJSONTyped(json, false);
}

export function TravelineBookingRoomStayRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRoomStayRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'stayDates': TravelineBookingStayDatesDtoFromJSON(json['stayDates']),
        'ratePlan': TravelineBookingRatePlanRqDtoFromJSON(json['ratePlan']),
        'roomType': TravelineBookingRoomTypeRqDtoFromJSON(json['roomType']),
        'guests': ((json['guests'] as Array<any>).map(TravelineBookingGuestDtoFromJSON)),
        'guestCount': TravelineBookingGuestCountDtoFromJSON(json['guestCount']),
        'checksum': json['checksum'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(TravelineRoomStayServiceRqDtoFromJSON)),
        'extraStay': json['extraStay'] == null ? undefined : TravelineExtraStayDtoFromJSON(json['extraStay']),
    };
}

  export function TravelineBookingRoomStayRqDtoToJSON(json: any): TravelineBookingRoomStayRqDto {
      return TravelineBookingRoomStayRqDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRoomStayRqDtoToJSONTyped(value?: TravelineBookingRoomStayRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stayDates': TravelineBookingStayDatesDtoToJSON(value['stayDates']),
        'ratePlan': TravelineBookingRatePlanRqDtoToJSON(value['ratePlan']),
        'roomType': TravelineBookingRoomTypeRqDtoToJSON(value['roomType']),
        'guests': ((value['guests'] as Array<any>).map(TravelineBookingGuestDtoToJSON)),
        'guestCount': TravelineBookingGuestCountDtoToJSON(value['guestCount']),
        'checksum': value['checksum'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(TravelineRoomStayServiceRqDtoToJSON)),
        'extraStay': TravelineExtraStayDtoToJSON(value['extraStay']),
    };
}

